// @flow

export function getParsedPermissions(permissions = []) {
  const parsedPermissionStructure = getParsedPermissionStructure();

  return permissions.reduce((permissionObj, permission) => {
    const newObject = Object.assign({}, permissionObj);
    switch (permission.key) {
      //New Per

      case 'DIMS_CASE_SEARCH': {
        newObject.case.viewCaseSearch = true;
        break;
      }
      case 'DiMS_FWDCASANTANL': {
        newObject.case.canForwardCase = true;
        break;
      }

      case 'DiMS_PNDCAS': {
        newObject.case.canPendCase = true;
        break;
      }

      case 'DiMS_ADDCASDOC': {
        newObject.case.canAddDocuments = true;
        break;
      }

      case 'DiMS_ADDCASNTSCMT': {
        newObject.case.canAddNotes = true;
        break;
      }

      case 'DiMS_ALWUSRWOFCAS': {
        newObject.case.canWriteOffCase = true;
        break;
      }

      case 'DiMS_ASNCASUSRGRP': {
        newObject.case.canAssignCase = true;
        break;
      }

      case 'DiMS_BMKCAS': {
        newObject.case.canBookmark = true;
        break;
      }
      //
      case 'DIMS_BULK_ASSIGNMENT': {
        newObject.queue.bulkAssigment = true;
        break;
      }

      case 'DiMS_CHSPAGMERIMGATHCAS': {
        newObject.queue.archiveImages = true;
        break;
      }

      case 'DiMS_MANADDTRNUNMTRNQUE': {
        newObject.queue.addManualTransaction = true;
        break;
      }
      //
      case 'DiMS_PERIMGCRPMERIMG': {
        newObject.queue.performImageOperations = true;
        break;
      }

      case 'DiMS_REDSNTINFOUTIMG': {
        newObject.case.redactImage = true;
        break;
      }

      case 'DiMS_SCHCASTRNATHMER': {
        newObject.case.searchWithFullPan = true;
        break;
      }
      //
      case 'DIMS_DATA_SEARCH': {
        newObject.search.dataSearch = true;
        break;
      }

      case 'DIMS_QUICK_SEARCH': {
        newObject.search.quickSearch = true;
        break;
      }

      case 'DiMS_UNASNCAS': {
        newObject.case.canUnAssignCase = true;
        break;
      }

      case 'DiMS_UNLNKIMGS': {
        newObject.queue.unlinkImage = true;
        break;
      }

      case 'DiMS_VIEW_MX_QUEUES': {
        newObject.queue.viewMxQueues = true;
        break;
      }
      case 'DiMS_VIEW_GP_QUEUES': {
        newObject.queue.viewGPNQueues = true;
        break;
      }
      case 'DiMS_VIEW_HPY_QUEUES': {
        newObject.queue.viewHPYQueues = true;
        break;
      }
      case 'DiMS_DELIMGSCHMERQUE': {
        newObject.case.deleteImageFromQueue = true;
        break;
      }

      case 'DiMS_VIWACCNBRCLRTXT': {
        newObject.accountNumber.canViewFullNumber = true;
        break;
      }

      case 'DiMS_VIWALLQUE': {
        newObject.queue.canViewAll = true;
        break;
      }

      case 'DiMS_VIWCASHIS': {
        newObject.case.viewCaseHistory = true;
        break;
      }

      case 'DiMS_VIWCASWTHQUE': {
        newObject.queue.viewCasesInQueue = true;
        break;
      }

      case 'DiMS_EXPCASSHT': {
        newObject.queue.canExportToSheet = true;
        break;
      }
      case 'DiMS_ACTRETCAS': {
        newObject.case.actionRetrieval = true;
        break;
      }
      case 'DiMS_ACTCBKCAS': {
        newObject.case.actionChargeback = true;
        break;
      }
      case 'DiMS_ACTPRGDISCAS': {
        newObject.case.actionProgressive = true;
        break;
      }
      case 'DiMS_ACTREJCAS': {
        newObject.case.actionRejected = true;
        break;
      }

      case 'DiMS_DLDLTRIMG': {
        newObject.document.download = true;
        break;
      }
      case 'DiMS_VIWINTRPT': {
        newObject.queue.viewInternalReports = true;
        break;
      }
      case 'DiMS_CFGQUECHSFIL': {
        newObject.queue.configureQueueUsingFilter = true;
        break;
      }
      case 'DiMS_ADDMDFADVMERWRKCAS': {
        newObject.case.addCustomMerchantVerbiage = true;
        break;
      }
      case 'DIMS_MSTR_PRMSN': {
        newObject.case.masterPermission = true;
        break;
      }
      case 'DiMS_CRTQUE': {
        newObject.queue.createQueue = true;
        break;
      }
      case 'DIMS_GNCASINQUE': {
        newObject.queue.getNextCaseInQueue = true;
        break;
      }
      case 'DiMS_STFRQUE': {
        newObject.queue.seeStatsForQueue = true;
        break;
      }
      case 'DIMS_VIWPRDRPT': {
        newObject.queue.viewProductivityReport = true;
        break;
      }
      case 'DiMS_VIWPRDDSH': {
        newObject.queue.viewProductDashboard = true;
        break;
      }
      case 'DiMS_UNDDECCASPRRUPLSCE': {
        newObject.queue.viewUnresolvedRTIReport = true;
        break;
      }
      case 'DiMS_VIEW_EVO_QUEUES': {
        newObject.queue.viewEvoQueues = true;
        break;
      }
      case 'DIMS_VIEW_GPE_QUEUES': {
        newObject.queue.viewGPEQueues = true;
        break;
      }
    }

    return newObject;
  }, parsedPermissionStructure);
}

export function getAdminSectionAccess(permissions = {}) {
  if (permissions.users) {
    const userAdminPermissions = [
      'canView',
      'canCreate',
      'canEditRole',
      'canEditOptionalPermissions',
      'canEditDataAccess',
      'canActivateAndDeactivate',
      'canEditProducts',
      'canViewAnalyticsBanner',
    ];

    const hasAdminThroughUser = userAdminPermissions.some((userPermission) => {
      return permissions.users[userPermission];
    });

    if (hasAdminThroughUser) {
      return true;
    }
  }

  if (permissions.merchants) {
    const merchantAdminPermissions = [
      'canView',
      'canRegister',
      'canEdit',
      'canOwnMerchants',
      'canTransferOwnership',
      'canViewProductSelection',
      'canUpdateProductPricing',
    ];

    const hasAdminThroughMerchant = merchantAdminPermissions.some((merchantPermission) => {
      return permissions.merchants[merchantPermission];
    });

    if (hasAdminThroughMerchant) {
      return true;
    }
  }

  return false;
}

export function getParsedPermissionStructure() {
  return {
    case: {
      /*  canAssignCase: false,
       canUnAssignCase: false,
       canForwardCase: false, */
      //viewCaseSearch: true
    },
    queue: {
      // canViewAll: true,
      /*canViewCaseWithinQueue: false, */
      //bulkAssigment: false
    },
    accountNumber: {
      /* canViewFullNumber: false */
    },
    search: {
      /* canViewFullNumber: false */
    },
    document: {},
  };
}

export function getAcquirerAccessList() {
  let state = sessionStorage.getItem('state');
  let userMXPermissions = JSON.parse(state ? state : '').auth.user.parsedPermissions.queue.viewMxQueues;
  let userGPPermissions = JSON.parse(state ? state : '').auth.user.parsedPermissions.queue.viewGPNQueues;
  let userHPYPermissions = JSON.parse(state ? state : '').auth.user.parsedPermissions.queue.viewHPYQueues;
  let userEVOPermissions = JSON.parse(state ? state : '').auth.user.parsedPermissions.queue.viewEvoQueues;
  let userGPEPermissions = JSON.parse(state ? state : '').auth.user.parsedPermissions.queue.viewGPEQueues;

  var acquirerAccess = [];

  if (userMXPermissions) {
    acquirerAccess.push('MXP');
    acquirerAccess.push('MXI');
  }
  if (userGPPermissions) {
    acquirerAccess.push('GPN');
    acquirerAccess.push('GPNPD');
  }
  if (userHPYPermissions) {
    acquirerAccess.push('HPY');
    acquirerAccess.push('HPYPD');
  }
  if (userEVOPermissions) {
    acquirerAccess.push('EMD');
    acquirerAccess.push('EMI');
  }
  if (userGPEPermissions) {
    acquirerAccess.push('GPE');
  }
  return acquirerAccess;
}

export default {
  getParsedPermissions,
  getParsedPermissionStructure,
  getAcquirerAccessList,
};
